// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"850b852e","239":"031780ec","455":"514c8db8"}[chunkId] + ".chunk.js";
};